import moment from "jalali-moment";
import { memo, useEffect, useMemo, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { useSelector } from "react-redux";

const ChartComponent = props => {
    const { data } = props;
    const darkMode = useSelector(state => state.theme.darkMode);

    useEffect(() => {
        setState(prev => ({
            ...prev,
            options: {
                ...prev.options,
                theme: {
                    mode: darkMode ? "dark" : "light"
                }
            }
        }));
    }, [darkMode])

    const chartData = useMemo(() => {
        const counts = [];
        const prices = [];
        const days = [];

        data.data.order_graph_last_month.forEach(el => {
            counts.push(el.count);
            prices.push(el.price);
            days.push(moment.unix(el.day).format("jYYYY/jMM/jD"));
        })

        return {
            counts,
            prices,
            days
        }
    }, [data])

    const [state, setState] = useState({
        series: [{
            name: 'تعداد فروش',
            data: chartData.counts
        }, {
            name: 'مبلغ فروش',
            data: chartData.prices
        }],
        options: {
            chart: {
                height: 350,
                type: 'area',
                fontFamily: 'IRANSans'
            },
            dataLabels: {
                enabled: false
            },
            stroke: {
                curve: 'smooth'
            },
            xaxis: {
                type: 'category',
                categories: chartData.days
            },
            tooltip: {
                x: {
                    format: 'dd/MM/yy HH:mm'
                },
            },
        },
    })

    return (
        <div className="wrap-box tp-22">
            <div className="p-4">
                <ReactApexChart
                    options={state.options}
                    series={state.series}
                    type="area"
                    height={350}
                />
            </div>
        </div>
    )
}

export default memo(ChartComponent);